export const Preloader = ({ loading }) => {
  return (
    <div className={`preloader ${!loading ? 'fade-out' : ''}`}>
      <div className="preloader-logo">
        <img 
          src="/logo.png" 
          alt="Bilal Ganj Auto Parts" 
          className="w-48 h-auto"
        />
      </div>
    </div>
  );
};

export default Preloader;